import { OptionsControl } from './options.model';
import { BaseControl } from '@app/shared/dynamic-form/shared/controls/base-control';

export interface Option {
  key: string | number;
  value: any;
  hidden?: boolean;
  others?: any;
}
interface OptionsDropdown extends OptionsControl<any> {
  options: Array<Option>;
}

export class Dropdown extends BaseControl<any> implements OptionsDropdown {
  controlType = 'dropdown';
  options: Array<Option>;

  constructor(options: Partial<OptionsDropdown>) {
    super(options);
    this.options = options.options || [];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dynamic-form/shared/controls/dropdown.ts